import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=adc79f5e"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Journal.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('adc79f5e', component.options)
    } else {
      api.reload('adc79f5e', component.options)
    }
    module.hot.accept("./Journal.vue?vue&type=template&id=adc79f5e", function () {
      api.rerender('adc79f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/Journal.vue"
export default component.exports